export default {
    accepted_by: "Кіммен қабылданды",
    additional_costs: "Шығыстар",
    additional_discount_correction: "Қосымша жеңілдік үшін түзету",
    additional_income: "Қосымша кіріс",
    admin_statistics_future: "Әкімшінің алдағы күндердегі жаңа жазбалар туралы статистикасы",
    administrator_percent: "Әкімшінің пайызы",
    administrator_sum: "Әкімшінің сомасы",
    all_visits_of_current_branch_independent_of_status_including_cancelled: "Күйіне қарамастан, осы филиалға барулардың барлығы, соның ішінде тоқтатылды",
    apply: "Қолдану",
    assistant_percent: "Ассистенттің пайызы",
    assistant_sum: "Ассистенттің сомасы",
    average_cheque: "Орташа чек",
    average_conversion_per_doctor_per_day: "Күніне дәрігерлер бойынша орташа көрсеткіш",
    average_conversion_per_doctor_per_period: "Кезеңде дәрігерлер бойынша орташа көрсеткіш",
    average_qty_of_goods_in_cheque: "Түбіртектегі элементтердің орташа саны",
    balance_amount: "депозиттен төленді",
    balance_return: "Депозитті қайтару",
    became_permanent: "Тұрақты болды",
    by: "Кіммен",
    by_means: "Төлем нысаны бойынша",
    by_services: "Қызметтер бойынша",
    calculated_from_calendar_visit_duration: "Күнтізбедегі жазбаның ұзақтығынан есептеледі",
    came_again: "Қайта келді",
    came_among_patients: "Оның ішінде келді",
    came_later_over_total_primary: "Бірінші рет келушілерден қайталанатын келушілердің пайызы",
    cancel_date: "Бас тарту күні",
    cancel_reason: "Бас тарту себебі",
    cancelled_among_them: "Олардың жойылды",
    cancelled_visits: "Бас тартылған келулер",
    cash_flow_statement: "ҚА қозғалысы туралы есеп",
    cash_received_report_day_explanation: "Кезеңге алынған қаражат: бару төлемдері (депозит, бонус, кепілдік және т.",
    cashdesk_report: "Кассалық есеп",
    conversion: "Конверсия",
    conversion_came_to_permanent: "Түрлендіру (қажет -> тұрақты)",
    cos: "Өзіндік құны",
    cost_of_attracting_primary_patient: "Негізгі науқасты тарту құны",
    cost_of_materials: "Материалдардың құны",
    cost_of_visits_for_selected_interval: "Таңдалған аралықта аяқталған сапарлар құны",
    costs: "Шығыстар",
    crm_leads_analytics: "CRM өтінімдерді талдау",
    curator_id: "Курартордың Id",
    curator_name: "Куратордың аты",
    curator_percent: "Куратордың пайызы",
    curator_sum: "Куратордың сомасы",
    daily_report: "Бір күнге есеп",
    debt_payments: "Қарыздарды төлеу",
    debt_writeoff: "Қазырдарды есептен шығару",
    debtor: "Борышкер",
    debtors: "Борышкерлер",
    debtors_statement: "Борышкерлер туралы есеп",
    deleted_payments_registry: "Жойылған төлемдер тізілімі",
    deposit_movements: "Депозит қозғалыстары",
    deposit_reconciliation_report: "Депозитті салыстыру есебі",
    details_by_visits: "Келулер бойынша мәліметтер",
    did_not_came_again: "Қайта келген жоқ",
    did_not_come_among_patients: "Оның ішінде келгендер",
    doctor_load_percent: "% дәрігердің жүктеуі",
    doctor_name: "Дәрігер",
    doctor_percent: "Дәрігердің пайызы",
    doctor_salary: "Дәрігердің жалақысы",
    doctor_statistics: "Дәрігерлер бойынша статистика",
    doctor_sum: "Дәрігердің сомасы",
    doctors_conversion: "Дәрігерлер бойынша конверсия",
    doctors_load: "Дәрігерлерді жүктеу",
    duration: "Ұзақтығы",
    export_from: "жүктеу",
    exports: "Жүктеу",
    f057: "057 нысан",
    first_visit_date: "Алғашқы келу күні",
    first_visit_doctor: "Алғашқы келу дәрігері",
    full_name: "Аты",
    general_percent: "Жалпы пайыз",
    have_later_visits_independent_of_interval: "Таңдалған аралыққа қарамастан болашақ жазбалар бар",
    have_later_visits_within_selected_interval: "Таңдалған аралықта қосымша жазбалар бар",
    have_no_later_visits_independent_of_interval: "Таңдалған интервалға қарамастан, басқа жазбалар жоқ",
    hidden_columns: "Жасырылған бағандар",
    hide_cancelled_visits: "Жойылған келулерді жасыру",
    how_much_was_paid_for_visit_for_the_whole_time_independent_of_selected_period: "Таңдалған есеп беру аралығына қарамастан, бүкіл уақыт үшін бару үшін төлем",
    in_progress: "Процесте",
    includes_both_discount_on_specific_services_and_general_discount: "Арнайы қызметтерге жеңілдіктер және баруға жалпы жеңілдіктер кіреді",
    including_adjustment_for_general_visit_discount: "Жалпы бару жеңілдіктерін түзетуді қамтиды",
    including_weighted_average_adjustment_for_general_visit_discount: "Бір келуге жалпы жеңілдік үшін орташа өлшенген түзетуді қамтиды",
    income_by_doctors: "Дәрігерлер бойынша табыстар",
    income_by_services: "Қызметтер бойынша табыстар",
    initiator: "Бастамашы",
    invoiced: "Шоттар шығарылды",
    last_visit_date: "Соңғы келу күні",
    last_visit_doctor: "Соңғы келу дәрігері",
    last_visit_recommendation: "Соңғы келу ұсыныстары",
    list_of_patients_with_visits_in_this_branch_for_selected_interval: "Таңдалған аралық үшін осы филиалға барған науқастардың тізімі",
    margins: "Жалпы табыс",
    materials_movement_analytics: "Материалдардың қозғалысын талдау",
    minutes_visit_was_opened_in_control_system: "Хаттамалар «барулардың басталуы мен аяқталуы» бақылау жүйесінде ашылды",
    next_visit_date: "Келесі келу күні",
    next_visit_doctor: "Келесі келу дәрігері",
    number_of_patient_visits_for_given_interval: "Таңдалған аралық үшін пациентке бару саны",
    only_fiscal_cheques: "Тек фискальды чектер",
    only_fiscal_payments: "Тек фискальды төлемдер",
    only_paid: "Тек төленгендер",
    operation_type: "Операция түрі",
    orthodontist: "Ортодонт",
    orthopedist: "Ортопед",
    paid_for: "үшін төленді",
    paid_from_account: "Шоттан төленді",
    paid_invoices: "Төленген шоттар",
    paid_sum: "Төлем сомасы",
    patient_deposits: "Пациенттердің депозиттері",
    patient_id: "Пациенттің Id",
    patient_name: "Пациент",
    patient_source: "Пациент көзі",
    patient_status: "Пациенттің статусы",
    patients_conversion: "Пациенттің конверсиясы",
    payments_registry: "Төлем тізілімі",
    payments_within_interval_for_visits_happened_within_interval: "Таңдалған аралықта орын алған сапарлар үшін ғана таңдалған аралық үшін төлемдер сомасы",
    payments_within_interval_for_visits_happened_within_interval_excluding_refunds: "Таңдалған аралықта аяқталған сапарлар үшін ғана таңдалған аралық үшін төлемдер сомасы (қайтарусыз)",
    pdf_report: "Есептің PDF",
    permanent_among_patients: "Оның ішінде тұрақты пациенттермен келулер",
    pl_statement: "Кірістер және шығыстар туралы есеп",
    plan_treatment_complexes: "Кешендер",
    plan_treatments: "Емдеу жоспары",
    previous_visit_date: "Алдыңғы келу күні",
    price_before_discount: "Жеңілдікпен сомасы",
    primary: "Бастапқы",
    primary_among_patients: "Оның ішінде алғашқы пациенттермен келулер",
    primary_marketing_expenses: "Алғашқы маркетингтік шығындар",
    primary_records: "Бастапқылар - жазылды",
    primary_records_came: "Бастапқы - жетті",
    primary_records_cancelled: "Бастапқы - жойылды",
    primary_records_did_not_come: "Бастапқы – жеткен жоқ",
    primary_records_further: "Бастапқы – одан әрі жазылды",
    primary_records_revenue: "Бастапқы - пайда",
    product_name: "Өнім атауы",
    recorded_later: "Қайта жазылды",
    records: "Жазулар",
    records_count: "Келулер саны",
    refunds_within_interval: "Таңдалған аралық үшін ақшаны қайтарады",
    repeated: "Қайта",
    repeated_records: "Қайта - жазылды",
    repeated_records_came: "Қайта - жетті",
    repeated_records_cancelled: "Қайталанған - жойылды",
    repeated_records_did_not_come: "Қайта – жеткен жоқ",
    repeated_records_further: "Қайта – одан әрі жазылды",
    repeated_records_revenue: "Қайта - пайда",
    report_days_limit: "Есептілік кезеңін шектеу (күн)",
    report_is_too_heavy_confirm: "Есеп бетте қарау үшін тым үлкен, есепті excel файлына жүктеу керек пе?",
    revenue: "Пайда",
    revenue_per_hour: "Сағатына пайда",
    revenues: "Пайда",
    revenues_report_day_explanation: "Барлық жолдармен таңдалған кезеңдегі бару төлемдері, сонымен қатар қосымша табыс (бухгалтерлік есептен) және тауарларды сатудан түскен қаражат",
    salary_report: "Жалақы бойынша есеп",
    saldo: "Сальдо",
    sale_date: "Сатылған күн",
    sales_funnel_applications: "Қайталама: Өтінімдер мен өтініштер",
    sales_funnel_plans: "Қайталама: Емдеу жоспарлары",
    see_all: "Барлығын көру",
    see_only_yourself: "Өзін ғана көру",
    services_amount: "Қызметтер саны",
    show_block_as_free_time: "Блоктарды бос уақыт ретінде есептеу",
    show_completed_visits: "Келген келулерді көрсету",
    show_deleted: "Жойылғандарды көрсету",
    show_deleted_doctors: "Жойылған дәрігерлерді көрсету",
    show_only_new_patients: "Жаңа пациенттерді ғана көрсету",
    source_of_patient_acquisition: "Науқасты тартудың бастапқы көзі",
    source_of_visit_acquisition: "Жасау көзіне кіріңіз",
    source_type: "Дерек көзінің түрі",
    technic_percent: "Техниктің пайызы",
    technic_sum: "Техниктің сомасы",
    therapist: "Терапевт",
    total_acquiring_deductions: "Эквайринг бойынша шегерім жиыны",
    total_cost_of_services: "Қызметтерді барлық сомасы",
    total_materials_deductions: "Материалдар бойынша шегерім жиыны",
    total_patients: "Жазылған пациенттердің саны",
    total_payments: "Барлық төлемдер",
    total_primary: "Барлық бастапқылар",
    total_primary_patients_records: "Алғашқы науқастардың жалпы жазбалары",
    total_revenue: "Барлық пайдалар",
    total_salary: "Барлық жалақы",
    total_technic_laboratory_deductions: "Техника/зертхана бойынша шегерім жиыны",
    total_unique_primary_patients: "Жалпы бірегей алғашқы науқастар",
    total_with_deductions: "Шегеріммен сома",
    unique_patients_recorded_during_selected_report_interval: "Таңдалған есеп интервалында жазылған бірегей пациенттер саны",
    unique_patients_with_first_visit_for_interval: "Таңдалған аралықта бастапқы барумен ерекше науқастар",
    unpaid_invoices: "Төленбеген шот",
    updated_date: "Өзгерту күні",
    visit_id: "Жазбаның Id",
    visit_price_including_all_discounts: "Барлық жеңілдіктерді қосқанда бару құны",
    visit_statistics: "Келулер статистикасы",
    visits_by_source: "Дерек көздері бойынша келулер",
    visits_cost_over_services_count: "Қызметтер санына келу құны",
    visits_detailed: "Келулер (кеңейтілген)",
    visits_of_current_branch_which_has_services_or_has_status_other_than_not_come: "Қызметтер белгіленген немесе \"келмеді\" күйінен басқа күйі бар осы филиалға барулар",
    visits_of_current_branch_which_have_services_or_have_status_came: "Қызметтермен немесе «пациент келді» күйімен келулер",
    visits_price_including_all_discounts: "Барлық жеңілдіктерді қоса алғанда, бару құны",
    where_came_from: "Қайдан келді",
    who_cancelled: "Кім бас тартты",
    who_changed_status: "Кім статусты өзгертті (Төлем / Келді)",
    who_created: "Кіммен жасалды",
    who_updated: "Кіммен өзгертілді",
    with_patient: "Пациентпен",
    worked_days: "Пайдаланылған күндер",
    worked_hours: "Пайдаланылған сағат",
    your_report_is_processing: "Сіздің есебіңіз қалыптастырылуда. Сіз ол дайын болғанда хабарландыру аласыз."
}
